import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import desktopLogoBlack from "../../src/assets/images/logo_black.png";
import { useForgotPasswordMutation } from "../services/useForgotPasswordMutation";

const ForgotPasswordPage = () => {
  const { mutateAsync: forgot, isLoading: loading } =
    useForgotPasswordMutation();
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      email: "",
    },
  });

  const onSubmit = async (formData) => {
    try {
      const res = await forgot(formData);

      if (res && res.success) {
        const successMessage = res?.message || "success";
        let data = res?.data?.data;

        toast.success(successMessage);
        reset();
        // navigate("/reset-password");
      } else {
        const errorMessage = res?.message || "failed";

        toast.error(errorMessage);
        reset();
      }
    } catch (error) {
      console.error("Login failed with error:", error);
    }
  };

  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-[#cfc9ff33]">
      <div className="max-w-lg w-full p-6 bg-white rounded-lg shadow-md  2xl:max-w-xl  ">
        <div
          className="mb-2 flex justify-center"
          //   onClick={() => {
          //     window.location.href = "https://qualiphy.me/";
          //   }}
        >
          <img
            src={desktopLogoBlack}
            alt="desktop logo"
            className="cursor-pointer w-full h-auto object-contain"
            style={{ maxHeight: "100px" }}
          />
        </div>
        <div className="mb-6 text-center">
          <h2 className="text-2xl font-semibold mb-2">Forgot Password</h2>
          <p className="text-gray-600">
            No worries, we will help you reset it!
          </p>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-4">
            <label
              htmlFor="email"
              className="block text-gray-700 text-sm font-bold mb-2"
            >
              Email
            </label>
            <input
              type="email"
              id="email"
              className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                errors.email ? "border-red-500" : ""
              }`}
              placeholder="Email"
              {...register("email", {
                required: "Please enter your email",
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: "Please enter a valid email",
                },
              })}
            />
            {errors.email && (
              <p className="text-red-500 text-xs italic">
                {errors.email?.message}
              </p>
            )}
          </div>

          <div className="mb-4">
            <button
              type="submit"
              disabled={loading}
              className={`bg-[#8058FA] hover:bg-[#6344c7] text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full ${
                loading ? "opacity-50 cursor-not-allowed" : ""
              }`}
            >
              {loading ? "Sending..." : "Send Instructions"}
            </button>
          </div>
        </form>

        <div
          className="flex items-center justify-center gap-3 hover:text-slate-700 cursor-pointer"
          onClick={() => navigate("/login")}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-5 h-5"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18"
            />
          </svg>
          <p>Back to login</p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
